export default __webpack_public_path__ + "static/media/babavelisekiz5.15413ecb.jpg";